export default {
  TIMEFRAME_OPTIONS: 'TIMEFRAME_OPTIONS',
  DELIVERY_DATA_TABLE: 'DELIVERY_DATA_TABLE',
  NOTIFICATION: 'NOTIFICATION',
};
